import '@/css/app.css'
import Alpine from 'alpinejs'
import Headroom from 'headroom.js'
import collapse from '@alpinejs/collapse'
import './cookie-consent-mode.js'
import './base/revealOnScroll.js'
import './base/parallax.js'

import './components/osmo/btn-stagger.js'
import './components/osmo/rotating-text.js'
import './components/osmo/logoWall.js'

import './components/curvedGallery.js'

import Lenis from 'lenis'
const lenis = new Lenis({
    autoRaf: true,
    anchors: {
        offset: -50
    },
    prevent: (node) => {
        const classes = ['pm-wrapper']
        return classes.some((cls) => node.classList.contains(cls))
    }
})

window.lenis = lenis

const headroom = () => {
    const headroom = new Headroom(document.querySelector('header'), {
        offset: 25,
        onTop: function () {
            document.querySelector('body').classList.add('headroom--top')
            document.querySelector('body').classList.remove('headroom--not-top')
        },

        onNotTop: function () {
            document.querySelector('body').classList.remove('headroom--top')
            document.querySelector('body').classList.add('headroom--not-top')
        }
    }).init()
}

// App main
const main = async () => {
    headroom()
    // Dit komt overeen met de twig var blockHandle
    // const blocks = []
    const components = [
        'fancybox',
        'swiper',
        'accordionComp',
        'langSwitcher',
        'googleMaps',
        'faq',
        'count',
        'plyr'
    ]

    const importPromises = []

    // for (const block of blocks) {
    //     const blockElements = document.querySelectorAll(`.${block}`)

    //     if (blockElements.length === 0) {
    //         continue
    //     }

    //     const importPromise = import(`./blocks/${block}.js`).then(
    //         ({ init }) => {
    //             blockElements.forEach((block) => {
    //                 importPromises.push(init(block))
    //             })
    //         }
    //     )

    //     importPromises.push(importPromise)
    // }

    for (const comp of components) {
        const compElements = document.querySelectorAll(`.${comp}`)
        if (compElements.length === 0) {
            continue
        }

        const importPromise = import(`./components/${comp}.js`).then(
            ({ init }) => {
                compElements.forEach((comp) => {
                    importPromises.push(init(comp, lenis))
                })
            }
        )

        importPromises.push(importPromise)
    }

    importPromises.push(
        import('./base/animations.js').then(({ initAnimations }) =>
            initAnimations()
        )
    )

    importPromises.push(
        import('./base/menu.js').then(({ initMenu }) => initMenu())
    )
    return await Promise.all(importPromises)
}

main().then(() => {
    console.log('Vite <3')
    window.Alpine = Alpine

    Alpine.plugin(collapse)
    Alpine.start()

    const anchor = getAnchor()
    if (anchor) {
        const anchorElement = document.querySelector(`#${anchor}`)
        if (anchorElement) {
            setTimeout(() => {
                lenis.scrollTo(anchorElement, {
                    offset: -50
                })
            }, 500)
        }
    }
})

const getAnchor = () => {
    var currentUrl = document.URL,
        urlParts = currentUrl.split('#')

    return urlParts.length > 1 ? urlParts[1] : null
}

if (import.meta.hot) {
    import.meta.hot.accept(() => {
        console.log('HMR')
    })
}
